"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _styles = require("@material-ui/core/styles");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const styles = theme => ({
  root: {
    borderBottom: `1px solid ${_constants.colours.activeFilter}`,
    marginBottom: 5,
    padding: '0 16px',
    [theme.breakpoints.up('md')]: {
      padding: '0 44px'
    }
  },
  indicator: {
    height: 3,
    backgroundColor: _constants.colours.primary
  },
  scrollButtons: {
    '&:first-of-type': {
      marginLeft: -50
    },
    '&:last-of-type': {
      marginRight: -50
    }
  }
});

const MyTabs = props => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Tabs.default, _extends({
    variant: "scrollable"
  }, props)));
};

var _default = (0, _styles.withStyles)(styles)(MyTabs);

exports.default = _default;